module.exports = __webpack_public_path__ + "static/media/hoisting-rigging.3ff9d3c6.jpg";